<script>
  export default {
    inheritAttrs: false,
    name: 'read-text',
    props: {
      placement: {
        type: String,
        default: 'bottom'
      },
      // 动画
      transition: {
        type: String,
        default: 'fade-in-linear'
      },
      // 鼠标是否可进入到 tooltip 中
      enterable: {
        type: Boolean,
        default: true
      },
      // 强制展示
      forceShow: {
        type: Boolean,
        default: false
      },

      // 值
      value: {
        type: [String, Number],
        default: ''
      },

      // 是否显示tip
      showTooltip: {
        type: Boolean,
        default: true
      },

      // 展示内容
      tip: {
        type: String,
        default: ''
      },

      // 提示语
      placeholder: {
        type: String,
        default: ''
      },

      // 最大长度
      maxLength: {
        type: Number,
        default: 50
      },

      // 行数量
      line: {
        type: Number,
        default: 2
      },

      openDelay: {
        type: Number,
        default: 500
      },

      computeHeight: {
        type: Boolean,
        default: false
      },

      // tip展示样式
      whiteSpace: {
        default: 'normal'
      }
    },
    computed: {
      disabled () {
        if (!this.showTooltip) {
          return true
        }
        return !this.isTooltip
      }
    },
    data () {
      return {
        isTooltip: false
      }
    },
    created () {
      this.className = !this.showTooltip ? '' : (this.line === 1 ? 'uniline' : 'line-clamp')
    },
    methods: {
      handleOver (e) {
        const {showTooltip, line} = this
        if (this.forceShow) {
          this.isTooltip = true
          return
        }
        if (!showTooltip) {
          return
        }
        const node = e.target
        const fontSize = node.currentStyle ? node.currentStyle['fontSize'] : getComputedStyle(node, null)['fontSize']
        let range = document.createRange()
        let rangeWidth = 0
        if (line !== 1) {
          const cloneNode = node.cloneNode(true)
          document.body.appendChild(cloneNode)
          cloneNode.style['fontSize'] = fontSize === '0px' ? '12px' : fontSize
          range.setStart(cloneNode, 0)
          range.setEnd(cloneNode, cloneNode.childNodes.length)
          if (this.computeHeight) {
            let rangeHeight = range.getBoundingClientRect().height / line
            cloneNode.parentNode.removeChild(cloneNode)
            node.style['webkitLineClamp'] = line
            const padding = parseInt(node.currentStyle ? node.currentStyle['padding'] : getComputedStyle(node, null)['padding'])
            this.isTooltip = (rangeHeight + padding + 2 > node.offsetHeight || node.scrollHeight > node.offsetHeight)
            return
          }
          rangeWidth = range.getBoundingClientRect().width / line
          cloneNode.parentNode.removeChild(cloneNode)
          node.style['webkitLineClamp'] = line
        } else {
          range.setStart(node, 0)
          range.setEnd(node, node.childNodes.length)
          rangeWidth = range.getBoundingClientRect().width
        }
        const padding = parseInt(node.currentStyle ? node.currentStyle['padding'] : getComputedStyle(node, null)['padding'])
        this.isTooltip = (rangeWidth + padding + 2 > node.offsetWidth || node.scrollWidth > node.offsetWidth)
      }
    },
    render (h) {
      const {disabled, value, handleOver, className, openDelay, $slots, forceShow, placement, enterable, transition, whiteSpace } = this
      const style = {}
      if (!forceShow) {
        style.width = '100%'
      }
      return (
        <div class="read-text" style>
          <el-tooltip 
            class="tip-value-default" 
            popper-class="sy-paas-com-basis-read-text-tooltip-popper" 
            effect="dark" 
            disabled={disabled} 
            open-delay={openDelay}
            placement={placement}
            transition={transition}
            enterable={enterable}
          >
            <div slot="content" class='content-scroll' style={{'whiteSpace': whiteSpace}}>
              {$slots.content ? $slots.content : value}
            </div>
            <div slot="default" on-mouseenter={handleOver} class={className}>
              {$slots.title ? $slots.title : value}
            </div>
          </el-tooltip>
        </div>
      )
    }
  }
</script>

<style lang="scss" scoped>
  .read-text {
    position: relative;
    display: inline-block !important;
    vertical-align: top;
  }

  .tip-value-default {
    // font-size: 12px;
    white-space: pre-wrap;
    word-break: break-all;
  }

  .uniline {
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap !important;
    width: 100%;
  }

  .line-clamp {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* autoprefixer: ignore next */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .content-scroll{
    max-height: 500px;
    overflow-y: auto; 
    // white-space: pre-line;
    // white-space: pre-wrap;
  }
  .content-scroll::-webkit-scrollbar {
    display: none;
  }
</style>

<style>
.sy-paas-com-basis-read-text-tooltip-popper {
  max-width: 300px;
}
</style>
